import _extends from "@babel/runtime/helpers/extends";
/**
 * @name androidstudio
 */
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export var defaultSettingsAndroidstudio = {
  background: '#282b2e',
  foreground: '#a9b7c6',
  caret: '#00FF00',
  selection: '#4e5254',
  selectionMatch: '#4e5254',
  lineHighlight: '#7f85891f'
};
export var androidstudioDarkStyle = [{
  tag: [t.keyword, t.deleted, t.className],
  color: '#cc7832'
}, {
  tag: [t.number, t.literal, t.derefOperator],
  color: '#6897bb'
}, {
  tag: [t.link, t.variableName],
  color: '#629755'
}, {
  tag: [t.comment, t.quote],
  color: 'grey'
}, {
  tag: [t.meta, t.documentMeta],
  color: '#bbb529'
}, {
  tag: [t.string, t.propertyName, t.attributeValue],
  color: '#6a8759'
}, {
  tag: [t.heading, t.typeName],
  color: '#ffc66d'
}, {
  tag: [t.attributeName],
  color: '#a9b7c6'
}, {
  tag: [t.emphasis],
  fontStyle: 'italic'
}];
export var androidstudioInit = options => {
  var {
    theme = 'dark',
    settings = {},
    styles = []
  } = options || {};
  return createTheme({
    theme: theme,
    settings: _extends({}, defaultSettingsAndroidstudio, settings),
    styles: [...androidstudioDarkStyle, ...styles]
  });
};
export var androidstudio = androidstudioInit();